class Config {
    backendAPI = 'https://backend.aumagic.com.au/api';
    // backendAPI = 'http://localhost:8000/api';
    accessTokenKey = btoa('accessToken');
    refreshTokenKey = btoa('refreshToken');
}

export default (new Config());
